module.exports = __webpack_public_path__ + "static/media/2.2ee76129.jpg";